import { store } from "@/store";
import { LicenseRest } from "@/services/rest/license.rest";
import LicenseInterface from "@/interfaces/License.interface";

export class LicenseService{
    constructor(
        private _licenses = new LicenseRest()
    ){}

    getLicenses(params: any){
        return this._licenses.getLicense(params).then((response) => {
            store.dispatch('licenses/setLicenses', response)
        })
    }

    getLicenseById(id: any){
        return this._licenses.getLicenseById(id).then((response) => {
            store.dispatch('licenses/setLicense', response)
        })
    }

    addLicense(data: LicenseInterface): Promise<any>{
        return this._licenses.addLicense(data)
    }

    updateLicense(id: any, data: any){
        return this._licenses.updateLicense(id, data)
    }

    deleteLicense(id: string): Promise<any>{
        return this._licenses.deleteLicense(id).catch((error) => {
            throw error.response.data
        })
    }

}